import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../types/user.class';

declare let FS: any;

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private apiBaseUrl: string;
  public userSubject = new BehaviorSubject<User>(new User());
  private user: User;

  constructor(private http: HttpClient) {
    this.apiBaseUrl = environment.serverURI + '/pos/api';
    const user = new User();
    this.user = Object.assign(user, JSON.parse(localStorage.getItem('profile')));
    this.userSubject.next(this.user);
  }

  /**
   * Returns the data received from current user call
   * Contains email, first & last name, Loans
   */
  public getActiveUser(): Observable<User> {
    return this.userSubject.asObservable();
  }

  public updateUser(user: User): void {
    localStorage.setItem('profile', JSON.stringify(user));
    this.userSubject.next(user);
  }

  public getCurrentUserWithAcl(hideLoader: boolean, nmls?): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.set('userTimeZone', Intl.DateTimeFormat().resolvedOptions().timeZone);
    if (nmls) {
      params = params.set('nmls', nmls);
    }
    if (hideLoader) {
      params = params.set('showLoader', 'false');
    }
    return this.http.get(`${this.apiBaseUrl}/wizeusers/current`, { params }).pipe(
      map((res: any) => {
        this.setFullStoryUserData(res);
        res.WizeOrgUnit.Broker = res.WizeOrgUnit.Broker || res.WizeOrgUnit.Lender;
        return res;
      })
    );
  }

  public updatePassword(payload: any) {
    return this.http.post(`${this.apiBaseUrl}/wizeusers/current/reset-password`, payload);
  }

  private setFullStoryUserData(user) {
    if (typeof FS !== 'undefined') {
      FS.setUserVars({
        displayName: user.email,
        email: user.email
      });
    }
  }
}
